module.exports = __webpack_public_path__ + "img/cost_icon_10.9fd29b0c.svg";